import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Cloudtrust() {
  return (
    <section className="cloud_trust p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={6}
            lg={5}
            xl={5}
            xxl={5}
            className="my-auto resp_order"
          >
            <StaticImage
              src="../../images/services-usa/cloud-mig/cloud_mig_solution.webp"
              alt="tekrevol_web"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={665}
              height={610}
            />
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto offset-lg-1"
          >
            <h2>Why Trust TekRevol for Cloud Migration Solutions?</h2>
            <div className="cloud_solution_scroll">
              <ul>
                <li>
                  <strong>6+ Years</strong> of expertise in cloud consultation,
                  development, cost-optimization, & migration.
                </li>
                <li>
                  <strong>8+ Years</strong> of experience as a leading software
                  development company in the USA.
                </li>
                <li>
                  Recognized by{" "}
                  <strong>INC. 5000 and INC. 5000 Regionals</strong> for the
                  Southwest Region among the fastest growing companies list.
                </li>
                <li>
                  Received <strong>ISO 27001 Certification</strong> for
                  top-notch information security management across service
                  channels.
                </li>
                <li>
                  Serve over 30 industries, including finance, healthcare,
                  retail, and manufacturing with tailored cloud migration
                  solutions to bridge modern tech needs.
                </li>
                <li>
                  Completed 10+ cloud migration projects with a 99.9% uptime,
                  boosted operational efficiency, and 40% lesser IT
                  infrastructure costs.
                </li>
                <li>
                  Enabled an e-commerce brand to achieve a 50% reduction in page
                  load time and a 35% increase in customer engagement
                  post-migration.
                </li>
              </ul>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Cloudtrust;
